// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseDeadlineEntity from './entities/case-deadline.json';
import caseDeadlineMenu from '../pages/case-deadline/menu.json';
import caseDeadlineFullForm from '../pages/case-deadline/forms/full.json';
import caseDeadlineContextForm from '../pages/case-deadline/forms/context.json';
import caseDeadlineMiniForm from '../pages/case-deadline/forms/mini.json';
import caseDeadlineLookupForm from '../pages/case-deadline/forms/lookup.json';
import caseDeadlineTableView from '../pages/case-deadline/views/table.json';
import caseDeadlineCardsView from '../pages/case-deadline/views/cards.json';
import caseDeadlineCalendarView from '../pages/case-deadline/views/calendar.json';
import caseDeadlineDashboardView from '../pages/case-deadline/views/dashboard.json';

/** Тип запису «Строк справи» зі сторінками пакета: меню, форми та подання з pages/case-deadline/. */
export const caseDeadlineDefinition: IRecordTypeDefinition = {
  ...caseDeadlineEntity,
  views: assembleViewSet({
      table: caseDeadlineTableView,
      cards: caseDeadlineCardsView,
      calendar: caseDeadlineCalendarView,
      dashboard: caseDeadlineDashboardView,
  }),
  form: caseDeadlineFullForm,
  forms: { full: caseDeadlineFullForm, context: caseDeadlineContextForm, mini: caseDeadlineMiniForm, lookup: caseDeadlineLookupForm },
  menu: caseDeadlineMenu,
} as IRecordTypeDefinition;
